import { render, staticRenderFns } from "./OcorrenciaList.vue?vue&type=template&id=65c354e2&scoped=true"
import script from "./OcorrenciaList.vue?vue&type=script&lang=js"
export * from "./OcorrenciaList.vue?vue&type=script&lang=js"
import style0 from "./OcorrenciaList.vue?vue&type=style&index=0&id=65c354e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c354e2",
  null
  
)

export default component.exports